var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('full-calendar',{ref:"fullCalendar",attrs:{"default-view":"timeGridWeek","header":{
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
    },"week-numbers":true,"events":_vm.events,"plugins":_vm.calendarPlugins,"theme-system":"bootstrap"},on:{"eventClick":_vm.onEventClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }